
import { useState, useEffect, useRef } from 'react';
import { NoRecords, PageLoader } from '../../../lib/loader';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import moment from 'moment';
import { TopupTransaction } from '../index';
import { Search, Check, Copy } from 'lucide-react';
import { useDebounce } from '../../../hooks/debounce';
import { useParams } from 'react-router-dom';
import { copyToClipboard } from '../../../lib/copytoClipboard';
import { useModalContext } from '../../../contexts/ModalContext';
import { useToast } from '../../../hooks/usetoast';
import { useCheckAdminAccess } from '../../WhiteIp/api/whiteipapi';
import { logout } from '../../../hooks/logout';
import PermissionDenied from '../../common/permissionDenied';
import { WaitingLoader } from '../../../hooks/buttonLoad';
import { useBreadcrumbPagination } from '../../../hooks/useBreadcrumbPagination';
import BreadcrumbPagination from '../../../utils/BreadcrumbPagination';
import PropTypes from 'prop-types';
import { displayValue } from '../../../hooks/export';


const IconRenderer = ({ rowId, fromEmail, theme, onCopy }) => {
    const color = theme ? "white" : "black";
    const iconStyle = { marginLeft: 5, color };

    return fromEmail === rowId ? (
        <Check size={20} style={iconStyle} />
    ) : (
        <Copy
            onClick={onCopy}
            size={20}
            className="ml-5"
            style={{ ...iconStyle, cursor: "pointer" }}
        />
    );
};


function CardSpendHistory() {

    const [tempPage, setTempPage] = useState(0);
    const [tempRows, setTempRows] = useState(25);
    const [search, setSearch] = useState("");
    const { theme } = useModalContext();
    const toast = useToast();
    const searchText = useDebounce(search);
    const [double, setDouble] = useState(false);

    const { id } = useParams();
    const [fromEmail, setFromEmail] = useState(false);
    const { data: getTransactionHistory, isLoading } = TopupTransaction({
        id,
        page: searchText ? 0 : tempPage,
        size: tempRows,
        searchText,
        sortField: "createdAt",
        sortOrder: "desc",
        type: "CardSpend"
    });

    const totalRecords = getTransactionHistory?.data?.totalRecords || 0;

    const {
        page,
        rowsPerPage,
        totalPages,
        handleChangePage,
        handleChangeRowsPerPage
    } = useBreadcrumbPagination(totalRecords, tempRows);

    useEffect(() => {
        setTempPage(page);
    }, [page]);

    useEffect(() => {
        setTempRows(rowsPerPage);
    }, [rowsPerPage]);

    useEffect(() => {
        setTempPage(0);
        if (handleChangePage) {
            handleChangePage(null, 0);
        }
    }, [searchText]);

    const inputRef = useRef(null);

    useEffect(() => {
        if (inputRef.current) {
            inputRef.current.focus();
            const length = inputRef.current.value.length;
            inputRef.current.setSelectionRange(length, length);
        }
    });

    const copytxnhashAddress = async data => {
        setDouble(data._id)
        await copyToClipboard(data)
        toast.success("Copied")
        setTimeout(() => {
            setDouble()
        }, 800)
    }
    const copyUserEmailAddress = async data => {
        setFromEmail(data._id)
        await copyToClipboard(data?.senderEmail)
        toast.success("Copied")
        setTimeout(() => {
            setFromEmail()
        }, 800)
    }


    const checkAdminMutation = useCheckAdminAccess();
    const [access, setAccess] = useState(true);

    useEffect(() => {
        checkAdminAccess();
    }, []);


    const checkAdminAccess = async () => {
        try {
            const obj = { page: 'History' };
            const checkAdminRes = await checkAdminMutation.mutateAsync(obj);
            if (!checkAdminRes?.data?.status) {
                setAccess(false);
                logout();
            } else {
                setAccess(true);
            }
        } catch (error) {
            setAccess(false);
        }
    };


    const renderInternalTransactionHistoryTable = () => (
        getTransactionHistory?.data?.transactionHistory?.length > 0 ? (
            <>
                <div style={{ minHeight: "60vh" }}>
                    <div className='table-responsive'>
                        <Table sx={{ minWidth: 650 }} aria-label="internal transaction history table">
                            <TableHead>
                                <TableRow>
                                    <TableCell className='text-nowrap' align="center">S.NO</TableCell>
                                    <TableCell className='text-nowrap' align="center">Email</TableCell>
                                    <TableCell className='text-nowrap' align="center">Txn Hash</TableCell>
                                    <TableCell className='text-nowrap' align="center">Amount</TableCell>
                                    <TableCell className='text-nowrap' align="center">Status</TableCell>

                                    <TableCell className='text-nowrap' align="center">
                                        Date & Time{' '}
                                    </TableCell>
                                </TableRow>
                            </TableHead>
                            <TableBody>
                                {getTransactionHistory?.data?.transactionHistory?.map((row, i) => (
                                    <TableRow key={row?._id || i}>
                                        <TableCell className='text-nowrap' align="center">{page * rowsPerPage + (i + 1)}</TableCell>
                                        <TableCell align="center">
                                            {row?.senderEmail || "-"}
                                            <IconRenderer rowId={row._id} fromEmail={fromEmail} theme={theme} onCopy={() => copyUserEmailAddress(row)} />
                                        </TableCell>


                                        <TableCell align="center">
                                            {row.txnId ? (
                                                <>
                                                    {`${row.txnId.slice(0, 5)}...${row.txnId.slice(-5)}`}
                                                    {double === row._id ? (
                                                        <Check size={20} style={{ marginLeft: "5px", color: theme ? "white" : "black" }} />
                                                    ) : (
                                                        <Copy
                                                            onClick={() => copytxnhashAddress(row?.txnId)}
                                                            size={20}
                                                            className="ml-5"
                                                            style={{ cursor: "pointer", marginLeft: "5px", color: theme ? "white" : "black" }}
                                                        />
                                                    )}

                                                </>
                                            ) : (
                                                "----"
                                            )}
                                        </TableCell>



                                        <TableCell className="text-nowrap" align="center">
                                            {row?.sentAmount ? (
                                                <span style={{ display: 'inline-flex', alignItems: 'center', gap: '4px' }}>
                                                    {displayValue(row.sentAmount, 6)}
                                                    {row?.currencySymbol ? (
                                                        <span style={{ display: 'inline-flex', alignItems: 'center', gap: '4px' }}>
                                                            <span className=' fw-bold'>{row.currencySymbol}</span>
                                                            {row?.currencyImage && (
                                                                <img
                                                                    src={row.currencyImage}
                                                                    alt="Currency Icon"
                                                                    style={{
                                                                        height: '20px',
                                                                        width: '20px',
                                                                        borderRadius: '50%',
                                                                        verticalAlign: 'middle',
                                                                        objectFit: 'cover',
                                                                    }}
                                                                />
                                                            )}
                                                        </span>
                                                    ) : (
                                                        '-'
                                                    )}
                                                </span>
                                            ) : (
                                                '-'
                                            )}
                                        </TableCell>
                                        <TableCell className="text-nowrap" align="center">
                                            <span
                                                style={{
                                                    color:
                                                        row?.transactionStatus === "completed"
                                                            ? "green"
                                                            : row?.transactionStatus === "pending"
                                                                ? "orange"
                                                                : "red",
                                                    fontWeight: 600,
                                                }}
                                            >
                                                {row?.transactionStatus === "completed"
                                                    ? "Completed"
                                                    : row?.transactionStatus === "pending"
                                                        ? "Pending"
                                                        : "Failed"}
                                            </span>
                                        </TableCell>

                                        <TableCell className='text-nowrap' align="center">
                                            {moment(row?.createdAt).format("DD-MM-YYYY | hh:mm A")}
                                        </TableCell>
                                    </TableRow>
                                ))}
                            </TableBody>
                        </Table>
                    </div>
                </div>
                <BreadcrumbPagination
                    page={page}
                    rowsPerPage={rowsPerPage}
                    totalPages={totalPages}
                    totalRecords={totalRecords}
                    handleChangePage={handleChangePage}
                    handleChangeRowsPerPage={handleChangeRowsPerPage}
                />
            </>
        ) : (
            <NoRecords />
        )
    );

    let content;

    if (isLoading) {
        content = <WaitingLoader />;
    } else if (access) {
        const tableContent = isLoading ? (
            <PageLoader />
        ) : (
            renderInternalTransactionHistoryTable()
        );

        content = (
            <section>
                <h4>Card Spend History</h4>
                <div className="ad_pg_bx bg-white p-3">
                    <div className="d-flex justify-content-between align-items-center mb-2">
                        <div className="col-md-4">
                            <div className="input-group">
                                <span className="input-group-icon">
                                    <Search size={20} color="#aaa9a9" />
                                </span>
                                <input
                                    type="text"
                                    ref={inputRef}
                                    onChange={(e) => setSearch(e.target.value)}
                                    className="form-control"
                                    placeholder="Search Email"
                                    value={search}
                                />
                            </div>
                        </div>
                    </div>
                    {tableContent}
                </div>
            </section>
        );
    } else {
        content = <PermissionDenied />;
    }

    return <>{content}</>;

}

IconRenderer.propTypes = {
    rowId: PropTypes.any,
    fromEmail: PropTypes.any,
    theme: PropTypes.any,
    onCopy: PropTypes.any,
};

export default CardSpendHistory;